import * as React from 'react';
import { connectCurrentRefinements } from 'react-instantsearch-core';
import { Button } from '@grandvisionhq/common';
import { useIntl } from '@grandvisionhq/state';
import { useItemsToClear } from '../../hooks/use-items-to-clear.js';

const ClearRefinements = ({ items , refine  })=>{
    const { getLabel  } = useIntl();
    const itemsToClear = useItemsToClear(items);
    const handleClick = React.useCallback(()=>{
        refine(itemsToClear);
    }, [
        refine,
        itemsToClear
    ]);
    if (!itemsToClear.length) {
        return null;
    }
    return /*#__PURE__*/ React.createElement(Button, {
        className: "clear-refinements",
        onClick: handleClick,
        caption: getLabel('search.filters.clearAll'),
        variant: "ghost",
        size: "custom",
        "data-t": "clear-refinements-button"
    });
};
var ClearRefinements$1 = connectCurrentRefinements(ClearRefinements);

export { ClearRefinements$1 as default };
//# sourceMappingURL=ClearRefinements.js.map
